import { HeaderBarSkeleton, PageWithSidePanel, SidePanelSkeleton } from '@gitbook/spine-react';

import { SpaceContentSkeleton } from './SpaceContentSkeleton';

/**
 * Skeleton of the entire space screen.
 */
export function SpaceScreenSkeleton(props: { withSidePanel: boolean }) {
    const { withSidePanel } = props;

    return (
        <PageWithSidePanel sidePanel={withSidePanel ? <SidePanelSkeleton /> : null}>
            <SpaceScreenBodySkeleton />
        </PageWithSidePanel>
    );
}

/**
 * Skeleton of the body of the space screen.
 */
export function SpaceScreenBodySkeleton() {
    return (
        <div className="flex flex-1 flex-col">
            <HeaderBarSkeleton />
            <SpaceContentSkeleton />
        </div>
    );
}
